// hooks/useSendActivationEmails.js

import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../../../api";

export const useSendActivationEmails = () => {
  const ApiClient = useApiClient();

  const sendActivationEmails = async (users) => {
    try {
      const result = await ApiClient.users.sendVerificationEmails({
        users: users.map((u) => u.id),
      });

      if (result.success) {
        enqueueSnackbar(result.message, {
          variant: "success",
          autoHideDuration: 3000,
        });

        return {
          success: true,
          result,
        };
      }

      enqueueSnackbar(result.message, {
        variant: "error",
        autoHideDuration: 3000,
      });

      return {
        success: false,
        result,
      };
    } catch (error) {
      console.error(error);

      enqueueSnackbar("There was a problem sending the emails", {
        variant: "error",
        autoHideDuration: 3000,
      });

      return {
        success: false,
        error,
      };
    }
  };

  return {
    sendActivationEmails,
  };
};
